import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import { WithTabTitle } from '../../../../common/widgets/withTabTitle';
import { ContactPage } from '../../Pages/Help/ContactPage';
import { HelpSectionDetailsPage } from '../../Pages/Help/SectionDetailsPage';
import { HelpSectionsPage } from '../../Pages/Help/SectionsPage';
import { resources } from '../../resources/resources';

export const HelpRoutes = () => {
  const { t: translate } = useTranslation();
  return (
    <Routes>
      <Route
        path=""
        element={
          <WithTabTitle title={translate(resources.menu.help)}>
            <HelpSectionsPage />
          </WithTabTitle>
        }
      />
      <Route
        path="sections/:sectionId"
        element={
          <WithTabTitle title={translate(resources.help.title)}>
            <HelpSectionDetailsPage />
          </WithTabTitle>
        }
      />
      <Route
        path="contact"
        element={
          <WithTabTitle title={translate(resources.help.contact.title)}>
            <ContactPage />
          </WithTabTitle>
        }
      />
    </Routes>
  );
};
